export function dateCountHelper(date, count){
  let dateCount = (count+1)*100000000
  let day = date.getDate()*1000000
  let month = date.getMonth()*10000
  let year = date.getFullYear();
  return dateCount+day+month+year;
}